import { SelectProps } from "../../types";

export const isControlledComponent = (
  searchValueFromProps: SelectProps["searchValue"],
  { searchable }: Pick<SelectProps, "searchable">
): searchValueFromProps is string =>
  searchable === true && typeof searchValueFromProps === "string";
